
import React, { useEffect, useState } from 'react'
import CustomTable from '../../Components/Table/CustomTable';

import { Grid } from '@mui/material';
import AllUserListCreateModal from './Modal/AllUserListCreateModal';
import TableDataViewModal from './Modal/TableDataViewModal';
import { setHeaderName, setSubHeaderName } from '../../ReduxStore/Slices/headerSlice';
import actions from "../../ReduxStore/actions/index";
import { useDispatch, useSelector } from "react-redux";
import { format } from 'date-fns';

const PurchaserList = () => {

  const dispatch = useDispatch()

  const tableData = [
    { PurchaserName: 'Vallarasu', Email: "valla@gmail.com", SchemePurchased: "Scheme1,Scheme2", PurchaseDate: "15 Jan 2025", Maturity: "18 Jan 2027" },
    { PurchaserName: 'Pravin', Email: "pravin@gmail.com", SchemePurchased: "Scheme2", PurchaseDate: "15 Jan 2025", Maturity: "18 Jan 2027" },
    { PurchaserName: 'Shahul', Email: "shahul@gmail.com", SchemePurchased: "Scheme2", PurchaseDate: "15 Jan 2025", Maturity: "18 Jan 2027" },
    { PurchaserName: 'Ramesh', Email: "Ramesh@gmail.com", SchemePurchased: "Scheme2", PurchaseDate: "15 Jan 2025", Maturity: "18 Jan 2027" },
    { PurchaserName: 'Sanjeev', Email: "Sanjeev@gmail.com", SchemePurchased: "Scheme2", PurchaseDate: "15 Jan 2025", Maturity: "18 Jan 2027" },
  ];
  const tableHeadData = ['S.No', 'Purchaser Name',"Email Id", "Scheme Purchased", "Purchase Date", "Maturity"];


  const { getAllPurchasesListForAuthUser } = useSelector(
    (state) => state?.getAllPurchasesListForAuthUser
  );
  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: `getAllPurchasesListForAuthUser`,
      };
      await dispatch(actions.GETALLPURCHASESLISTFORAUTHUSER(data1));
    };
    fetchData();
  }, [dispatch]);

  const [rowTableData, setRowTableData] = useState([
    {
      PurchaserName: "--",
      purchase_id: "--",
      Email: "--",
      SchemePurchased: "--",
      PurchaseDate: "--",
      Maturity: "--",
    },
  ]);

  useEffect(() => {
    const tempArr = [];
    getAllPurchasesListForAuthUser?.data?.map((data, index) => {
      return tempArr.push({

        PurchaserName: `${data?.customer?.first_name} ${data?.customer?.last_name}`,
        purchase_id: data?.purchase_id,
        Email: data?.customer?.email,
        SchemePurchased: data?.title,
        PurchaseDate: format(new Date(data?.purchase_date), 'MMMM d, yyyy'),
        Maturity: format(new Date(data?.stake_maturity), 'MMMM d, yyyy'),

      });
    });
    setRowTableData(tempArr);
  }, [
    dispatch, getAllPurchasesListForAuthUser
  ]);




  React.useEffect(() => {
    dispatch(setHeaderName("Operator Registration"));
    dispatch(setSubHeaderName("Purchaser List"));
  }, [dispatch]);

  return (
    <Grid container spacing={2}>

      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable tableData={rowTableData} title="User List" tableHeadData={tableHeadData} 
        // dataCreate="dataCreate"
          modalVeiwName={TableDataViewModal}
          // tableEdit="tableEdit"
          tableView="tableview"

          modalHeadingName="Create User"
          modalViewHeadingName="Purchaser Detail"
        />

      </Grid>
    </Grid>
  )
}

export default PurchaserList